import Cookies from 'js-cookie';
import { AccountRegion } from '../@types/regionalApi';
import APIConfig from '../apiconfig';
import { ACCOUNT_REGION_COOKIE_KEY } from 'src/constants';
import { Analytics } from 'src/analytics';

export const missingAccountRegionErrorMessage = 'missing account region cookie';
export const unknownAccountRegionErrorMessage = 'unknown account region cookie';

type GetRegionalApiUrlOptions = {
  url: URL;
  accountRegion?: AccountRegion;
  forceGlobalApiHost?: boolean;
};

export const getAccountRegionCookie = () =>
  Cookies.get(ACCOUNT_REGION_COOKIE_KEY) as AccountRegion | undefined;

export const getRegionalApiUrl = ({
  url,
  accountRegion,
  forceGlobalApiHost,
}: GetRegionalApiUrlOptions) => {
  if (forceGlobalApiHost) {
    return applyGlobalApiHost(url);
  }

  if (accountRegion === undefined) {
    Analytics.track({
      event: missingAccountRegionErrorMessage,
    });
    console.error(
      `${missingAccountRegionErrorMessage} defaulting to global API host`
    );
    return applyGlobalApiHost(url);
  }

  if (isGlobalRegion(accountRegion)) {
    return applyGlobalApiHost(url);
  }

  if (isEURegion(accountRegion)) {
    return applyEUApiHost(url);
  }

  Analytics.track({
    event: unknownAccountRegionErrorMessage,
  });
  console.error(
    `${unknownAccountRegionErrorMessage} defaulting to global API host`
  );
  return applyGlobalApiHost(url);
};

export const applyEUApiHost = (url: URL) => {
  const euBaseUrl = new URL(APIConfig.euHost);
  const euUrl = new URL(url.toString());

  euUrl.host = euBaseUrl.host;
  euUrl.hostname = euBaseUrl.hostname;

  return euUrl;
};

export const applyGlobalApiHost = (url: URL) => {
  const globalBaseUrl = new URL(APIConfig.host);
  const globalUrl = new URL(url.toString());

  globalUrl.host = globalBaseUrl.host;
  globalUrl.hostname = globalBaseUrl.hostname;

  return globalUrl;
};

export const isGlobalRegion = (region: AccountRegion) =>
  region === AccountRegion.Global;

export const isEURegion = (region: AccountRegion) =>
  region === AccountRegion.EU;

export const getRegionalApiHost = (accountRegion: AccountRegion) => {
  if (isEURegion(accountRegion)) {
    return APIConfig.euHost;
  }

  return APIConfig.host;
};

type ValidateAccountRegionResult =
  | {
      success: true;
      accountRegion: AccountRegion;
    }
  | {
      success: false;
    };

export const validateAccountRegion = (
  accountRegion: string | undefined
): ValidateAccountRegionResult => {
  if (
    [AccountRegion.Global, AccountRegion.EU].includes(
      accountRegion as AccountRegion
    )
  ) {
    return {
      success: true,
      accountRegion: accountRegion as AccountRegion,
    };
  }

  return {
    success: false,
  };
};
